import { useEffect, useMemo, useState } from 'react';

import { api, CareServiceOrgansKey, ReportResponse } from '@/api';
import { categorizeFindings, groupFindingsByOrgan } from '@/shared/util';
import { useDefaultFindingStore, useFindingStore } from '@/store';

export function useUpdateFindingsStores(report: ReportResponse | undefined) {
  const [hydratedForUuid, setHydratedForUuid] = useState<string | undefined>(undefined);

  const { data: renderedSummaries, isLoading: isQueryLoading } =
    api.fct.renderedSummary.query.useGetReportRenderedSummaries({
      payload: { uuid: report?.uuid },
    });

  useEffect(() => {
    if (renderedSummaries === undefined) {
      return;
    }

    if (renderedSummaries.length) {
      const groupedData = groupFindingsByOrgan(renderedSummaries);

      Object.keys(groupedData).forEach((organ) => {
        const { commonFindings, defaultFindings: defaultFindingsData } = categorizeFindings(
          groupedData[organ as CareServiceOrgansKey],
        );

        useFindingStore.setState((state) => ({
          findings: { ...state.findings, [organ]: commonFindings },
        }));

        useDefaultFindingStore.setState((state) => ({
          defaultFindings: { ...state.defaultFindings, [organ]: defaultFindingsData },
        }));
      });
    }

    setHydratedForUuid(report?.uuid);
  }, [renderedSummaries, report?.uuid]);

  const isLoading =
    isQueryLoading || (renderedSummaries !== undefined && hydratedForUuid !== report?.uuid);

  const value = useMemo(() => ({ isLoading }), [isLoading]);

  return value;
}
